module.exports = __webpack_public_path__ + "img/正常发货.488b2c6a.svg";